import './css.js';

async function init() {
    await import('../../assets/unify/plugins/back-to-top.js');
    await import('../../assets/unify/plugins/smoothScroll.js');
    await import('../../assets/unify/plugins/jquery.parallax.js');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.js');

    let App = await import('../../assets/unify/js/app.js');
    let OwlCarousel = await import('../../assets/unify/js/plugins/owl-carousel.js');
    $(document).ready(function () {
        App.init();
        App.initParallaxBg();
        OwlCarousel.initOwlCarousel();
    });

    (async function ($) {
        let parsley = await import('parsleyjs');
        await import('parsleyjs/dist/i18n/' + locale.replace('-', '_').toLowerCase());
        let moment = await import('moment');
        let nowYear = moment().get('year');
        let nowMonth = moment().get('month');
        let nowDate = moment().get('date');

        $('#forget-password-email').attr({
            'data-parsley-required': true,
            'data-parsley-type': 'email',
            'data-parsley-errors-container': '#id-error-message'
        });
        $('#forget-password-year').attr({
            'data-parsley-required': true,
            'data-parsley-range': '[1900, ' + nowYear + ']'
        });
        $('#forget-password-month').attr({
            'data-parsley-required': true,
            'data-parsley-range': '[1, 12]'
        });
        $('#forget-password-date').attr({
            'data-parsley-required': true,
            'data-parsley-range': '[1, 31]'
        });

        let validator = parsley.$element.find('#forget-password-form').parsley({
            errorsWrapper: '<div></div>',
            errorTemplate: '<span class="color-red"></span>'
        });

        for (let i = 1900; i <= nowYear; ++i) {
            $('#forget-password-year').append($('<option>', {
                value: i
            }).text(i));
        }

        $('#forget-password-year').change(function () {
            $('#forget-password-month').find('option').not('[value="0"]').remove();
            if ($(this).val() == nowYear) {
                for (let i = 1; i <= nowMonth + 1; ++i) {
                    $('#forget-password-month').append($('<option>', {
                        value: i
                    }).text(i));
                }
            }
            else {
                for (let i = 1; i <= 12; ++i) {
                    $('#forget-password-month').append($('<option>', {
                        value: i
                    }).text(i));
                }
            }
        });

        $('#forget-password-year, #forget-password-month').change(function () {
            let year$ = $('#forget-password-year');
            let month$ = $('#forget-password-month');
            $('#forget-password-date').find('option').not('[value="0"]').remove();
            if (year$.val() !== null && month$.val() !== null) {
                if (year$.val() == nowYear && month$.val() == nowMonth + 1) {
                    for (let i = 1; i <= nowDate; ++i) {
                        $('#forget-password-date').append($('<option>', {
                            value: i
                        }).text(i));
                    }
                    $('#forget-password-date').attr('data-parsley-range', '[1, ' + nowDate + ']');
                }
                else {
                    let monthEnd = moment().set({
                        'year': parseInt(year$.val()),
                        'month': parseInt(month$.val()) - 1
                    }).endOf('month');

                    let End = monthEnd.get('date');

                    if($.inArray(parseInt(month$.val()), [1, 3, 5, 7, 8, 10, 12]) >= 0){
                        End = 31;
                    }else if($.inArray(parseInt(month$.val()), [4, 6, 9, 11]) >= 0){
                        End = 30;
                    }

                    for (let i = 1; i <= End; ++i) {
                        $('#forget-password-date').append($('<option>', {
                            value: i
                        }).text(i));
                    }
                    $('#forget-password-date').attr('data-parsley-range', '[1, ' + monthEnd.get('date') + ']');
                }
            }
        });

        $('#forget-password-submit').click(function () {
            validator.validate();
            if (validator.isValid()) {
                $('#forget-password-form').submit();
            }
        });
    })(jQuery);
}

init();


// WEBPACK FOOTER //
// ./webpack/forget/entry.js